<template>
  <div>
    <div v-if="isError.courses" class="flex items-center justify-center relative">
      <BlEmptyStateMv
        title="Kelas yang kamu cari tidak ditemukan"
        main-button-text="Muat ulang"
        alt-image="Image Error State"
        class="qa-error-courses"
        @mainButtonClick="reload"
      />
    </div>

    <template v-else>
      <!-- Filter and Sort -->
      <BlFlexContainerMv
        v-if="false"
        direction="row"
        align-items="center"
        justify-content="center"
        padding="12px 16px"
        class="border-bottom-gray"
      >
        <BlFlexItemAv grow="1" class="flex items-start justify-center pv-4 w-[50%]" style="border-right: 1px solid #ebebeb">
          <IcoFilterMinor />
          <BlTextAv variant="caption-12" class="ml-4">Filter</BlTextAv>
        </BlFlexItemAv>
        <BlFlexItemAv grow="1" class="flex items-start justify-center pv-4 w-[50%]">
          <IcoSortMinor />
          <BlTextAv variant="caption-12" class="ml-4">Terlaris</BlTextAv>
        </BlFlexItemAv>
      </BlFlexContainerMv>
      <!-- End of Filter and Sort -->

      <BlTextAv tag="h1" class="pt-16 pl-16" variation="caption-12">Daftar Prakerja di {{ merchantDetail.name }}</BlTextAv>

      <!-- First load shimmer -->
      <BlFlexContainerMv v-if="isAppLoading && !merchantCourses.length" padding="12px 16px" class="qa-prakerja-card-shimmer">
        <PrakerjaCardShimmer :count="8" />
      </BlFlexContainerMv>
      <!-- End of First load shimmer -->

      <!-- Empty courses -->
      <div v-else-if="!isAppLoading && !merchantCourses.length" class="relative">
        <BlEmptyStateMv
          type="full"
          title="Kelas yang kamu cari tidak ditemukan"
          description="Kamu bisa coba pakai kata pencarian lain"
          alt-image="Image Empty State"
          class="qa-empty-courses"
        />
      </div>
      <!-- End of Empty courses  -->

      <template v-else>
        <!-- Courses card -->
        <BlFlexContainerMv padding="16px">
          <div class="grid grid-cols-12 gap-3 w-full">
            <PrakerjaCard
              v-for="(course, id) in merchantCourses"
              :key="id"
              :course="course"
              :course-type="course.course_type"
              class="col-span-6 qa-prakerja-card"
              title-tag="h2"
            />
          </div>
        </BlFlexContainerMv>
        <!-- End Of Courses card  -->

        <!-- Shimmer infinite scroll -->
        <BlFlexContainerMv v-if="isAppLoading" padding="12px 16px">
          <PrakerjaCardShimmer :count="8" class="qa-infinite-scroll-shimmer" />
        </BlFlexContainerMv>
        <!-- End Of Shimmer infinite scroll  -->

        <!-- Info for all courses loaded -->
        <BlFlexContainerMv
          v-if="isAllCoursesLoaded && !isAppLoading && merchantCourses.length"
          padding="12px 16px 24px 16px"
          align-items="center"
          justify-content="center"
          class="qa-all-courses-loaded"
        >
          <BlTextAv color="subdued">Semua kelas telah ditampilkan</BlTextAv>
        </BlFlexContainerMv>
        <!-- End Info for all courses loaded  -->
      </template>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlEmptyStateMv} from '@bukalapak/bazaar-mweb-latest';
import {IcoFilterMinor, IcoSortMinor} from '@bukalapak/bazaar-visual-next';
import PrakerjaCardShimmer from '../PrakerjaCardShimmer/PrakerjaCardShimmer';
import PrakerjaCard from '../PrakerjaCard/PrakerjaCard';

export default {
  name: 'PrakerjaMerchantCourses',
  components: {BlEmptyStateMv, IcoFilterMinor, IcoSortMinor, PrakerjaCardShimmer, PrakerjaCard},
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      isError: 'getError',
      isAllCoursesLoaded: 'courses/getIsAllCoursesLoaded',
      merchantCourses: 'courses/getCourses',
      merchantDetail: 'merchants/getMerchantDetail',
    }),
  },
  methods: {
    reload() {
      this.$store.dispatch('courses/fetchCourses');
    },
  },
};
</script>

<style scoped>
.bl-empty-state--full {
  height: calc(100vh - 240px) !important;
}
</style>
